import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

import {TYPE_IMAGE, TYPE_TEXT} from "../constants";

require('moment/locale/de');
moment.locale('de');

export default function TimelineItemHeader({sender, recipient, date, type}) {

  const getTypeString = () => {
    switch (type) {
      case TYPE_IMAGE:
        return __("a picture");
      case TYPE_TEXT:
        return __("a message");
      default:
        return "";
    }
  };

  return (
    <div className="timelineHeader flexBox">
      <div className="userProfilePic"
           style={{backgroundImage: `url(${sender.image})`}}
      />
      <div className="flex">
        <div>
          <b>{sender.name}</b> hat <b>{recipient.name}</b> {getTypeString()} {__("posted")}.
        </div>
        <div>
          {moment(date).fromNow()}
        </div>
      </div>
    </div>
  );
}

TimelineItemHeader.propTypes = {
  sender: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired
  }),
  recipient: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired
  }),
  date: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};
